import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AssistantConversationsListQuery } from "../graphql/queries";
import type {
  AssistantConversationsListQueryType,
  AssistantConversationsListQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAssistantConversationsQuery = (
  options?: QueryHookOptions<
    AssistantConversationsListQueryType,
    AssistantConversationsListQueryVariablesType
  >
) => {
  return useQuery<
    AssistantConversationsListQueryType,
    AssistantConversationsListQueryVariablesType
  >(AssistantConversationsListQuery, options);
};
